var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"expandable-box"},[_c('button',{staticClass:"title-box",on:{"click":_vm.toggleExpanded}},[_c('h3',[_vm._v(_vm._s((_vm.isExpanded?'- ':'+ ')+ _vm.title))])]),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.isExpanded),expression:"isExpanded"}],staticClass:"description-box",attrs:{"id":"transcript"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }